import * as moment from 'moment';
export class NotificationAlerts {

 public countryCode?: string;
 public message?: string;
 public businessErrors?: number;
 public technicalErrors?: number;
 public createdDate?: moment.Moment;
 public subMessage?: string;

    static fromDto(r) {
      if (!r) {
        return null;
      }
        const notificationData           = new NotificationAlerts();
        notificationData.countryCode = r?.country_code;
        notificationData.message = r?.message;
        notificationData.businessErrors = r?.business_errors;
        notificationData.technicalErrors = r?.technical_errors;
        notificationData.createdDate = moment(r?.created_date);
        notificationData.subMessage = r?.sub_message;

        return notificationData;
      }

      static toDto(r: NotificationAlerts): any {
        if (!r) {
          return null;
        }

        return {
          country_code: r.countryCode,
          created_date: r.createdDate,
          message: r.message,
          business_errors: r.businessErrors,
          technical_errors: r.technicalErrors,
          sub_message: r.subMessage,
        };
      }
}
